// ── Colour palette ────────────────────────────────────────────
export const C = {
  bg:         '#0f1117',
  surface:    '#1e2329',
  surfaceAlt: '#161b22',
  border:     '#2a3040',
  teal:       '#14b8a6',
  tealDim:    'rgba(20,184,166,0.12)',
  text:       '#f0f2f5',
  muted:      '#6b7280',
  mutedDark:  '#4b5563',
  danger:     '#ef4444',
  dangerBg:   '#7f1d1d',
  dangerBorder: '#991b1b',
  dangerText: '#fca5a5',
};

// ── Shared style objects ──────────────────────────────────────
// Use with spread: { ...cs.modal, maxWidth: '400px' }
export const cs = {

  // Layout
  page:   { padding: '20px', fontFamily: 'system-ui, sans-serif', background: C.bg, minHeight: '100vh', color: C.text },
  center: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px', color: C.muted },

  // Cards
  card: { background: C.surface, border: `1px solid ${C.border}`, borderRadius: '10px', padding: '16px' },

  // Modals
  overlay:     { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'system-ui, sans-serif' },
  modal:       { background: C.surface, border: `1px solid ${C.border}`, borderRadius: '16px', width: '90%', maxWidth: '560px', maxHeight: '85vh', overflowY: 'auto' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 20px 16px', borderBottom: `1px solid ${C.border}`, position: 'sticky', top: 0, background: C.surface, zIndex: 1 },
  modalTitle:  { fontSize: '17px', fontWeight: '700' },
  modalBody:   { padding: '20px' },
  modalFooter: { display: 'flex', justifyContent: 'space-between', padding: '16px 20px', borderTop: `1px solid ${C.border}`, position: 'sticky', bottom: 0, background: C.surface },
  closeBtn:    { background: 'none', border: 'none', color: C.muted, fontSize: '18px', cursor: 'pointer' },

  // Tables
  tableWrap:   { background: C.surface, border: `1px solid ${C.border}`, borderRadius: '10px', overflowX: 'auto', WebkitOverflowScrolling: 'touch' },
  // gridTemplateColumns must be added per-table via spread
  tableHeader: { display: 'grid', gap: '12px', padding: '10px 16px', background: C.surfaceAlt, fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: C.muted, letterSpacing: '0.06em' },
  tableRow:    { display: 'grid', gap: '12px', padding: '12px 16px', borderTop: `1px solid ${C.border}`, alignItems: 'center' },

  // Forms
  input: { background: C.bg, border: `1px solid ${C.border}`, borderRadius: '6px', color: C.text, padding: '9px 12px', fontSize: '13px', fontFamily: 'system-ui, sans-serif', width: '100%', boxSizing: 'border-box' },
  label: { display: 'block', fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.06em', color: C.muted, marginBottom: '6px' },

  // Buttons
  btnPrimary:   { background: C.teal, color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 18px', fontSize: '13px', fontWeight: '700', cursor: 'pointer', whiteSpace: 'nowrap', fontFamily: 'system-ui, sans-serif' },
  btnSecondary: { background: C.surface, border: `1px solid ${C.border}`, color: '#9ca3af', borderRadius: '8px', padding: '10px 16px', fontSize: '13px', cursor: 'pointer', fontFamily: 'system-ui, sans-serif' },
  btnDanger:    { background: C.danger, color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 18px', fontSize: '13px', fontWeight: '700', cursor: 'pointer', fontFamily: 'system-ui, sans-serif' },

  // Feedback
  errorBanner: { background: C.dangerBg, color: C.dangerText, border: `1px solid ${C.dangerBorder}`, borderRadius: '8px', padding: '10px 14px', fontSize: '13px', marginBottom: '16px' },

  // Navigation breadcrumb
  breadcrumb: { display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' },
  backBtn:    { background: 'none', border: 'none', color: C.muted, fontSize: '12px', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', gap: '4px' },
  sep:        { color: C.border },
  crumb:      { fontSize: '12px', color: C.text },

  // Page header
  pageHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' },
  pageTitle:  { fontSize: '22px', fontWeight: '700', margin: '0 0 4px 0' },
  pageSub:    { fontSize: '13px', color: C.muted, margin: 0 },
};
